import { render, staticRenderFns } from "./recoverbox.vue?vue&type=template&id=4e5b9a48&scoped=true"
import script from "./recoverbox.vue?vue&type=script&lang=js"
export * from "./recoverbox.vue?vue&type=script&lang=js"
import style0 from "./recoverbox.vue?vue&type=style&index=0&id=4e5b9a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b9a48",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PzImage: require('/drone/src/components/PzImage/index.vue').default,Empty: require('/drone/src/components/Empty/index.vue').default})
